/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Failed_To_Start_Translation_JobsInputs */

const en_failed_to_start_translation_jobs = /** @type {(inputs: Failed_To_Start_Translation_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to start translation jobs. Please try again later.`)
};

const fr_failed_to_start_translation_jobs = /** @type {(inputs: Failed_To_Start_Translation_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec du démarrage des tâches de traduction. Veuillez réessayer plus tard.`)
};

const de_failed_to_start_translation_jobs = /** @type {(inputs: Failed_To_Start_Translation_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übersetzungsaufträge konnten nicht gestartet werden. Bitte versuchen Sie es später erneut.`)
};

const it_failed_to_start_translation_jobs = /** @type {(inputs: Failed_To_Start_Translation_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile avviare i lavori di traduzione. Riprova più tardi.`)
};

const ru_failed_to_start_translation_jobs = /** @type {(inputs: Failed_To_Start_Translation_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не удалось запустить задания на перевод. Пожалуйста, попробуйте позже.`)
};

const es_failed_to_start_translation_jobs = /** @type {(inputs: Failed_To_Start_Translation_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudieron iniciar los trabajos de traducción. Inténtelo de nuevo más tarde.`)
};

const zh_cn2_failed_to_start_translation_jobs = /** @type {(inputs: Failed_To_Start_Translation_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`翻译任务启动失败，请稍后再试。`)
};

const ja_failed_to_start_translation_jobs = /** @type {(inputs: Failed_To_Start_Translation_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`翻訳ジョブを開始できませんでした。しばらくしてからもう一度お試しください。`)
};

const hi_failed_to_start_translation_jobs = /** @type {(inputs: Failed_To_Start_Translation_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अनुवाद कार्य प्रारंभ करने में विफलता। कृपया बाद में पुनः प्रयास करें।`)
};

const pt_pt2_failed_to_start_translation_jobs = /** @type {(inputs: Failed_To_Start_Translation_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível iniciar as tarefas de tradução. Tente novamente mais tarde.`)
};

/**
* | output |
* | --- |
* | "Failed to start translation jobs. Please try again later." |
*
* @param {Failed_To_Start_Translation_JobsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const failed_to_start_translation_jobs = /** @type {((inputs?: Failed_To_Start_Translation_JobsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Failed_To_Start_Translation_JobsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_failed_to_start_translation_jobs(inputs)
	if (locale === "de") return de_failed_to_start_translation_jobs(inputs)
	if (locale === "it") return it_failed_to_start_translation_jobs(inputs)
	if (locale === "ru") return ru_failed_to_start_translation_jobs(inputs)
	if (locale === "es") return es_failed_to_start_translation_jobs(inputs)
	if (locale === "zh-CN") return zh_cn2_failed_to_start_translation_jobs(inputs)
	if (locale === "ja") return ja_failed_to_start_translation_jobs(inputs)
	if (locale === "hi") return hi_failed_to_start_translation_jobs(inputs)
	if (locale === "pt-PT") return pt_pt2_failed_to_start_translation_jobs(inputs)
	return en_failed_to_start_translation_jobs(inputs)
});